/**
 * Mass item upload Saga
 *
 * @author agal0301
 * */

import {
  all, call, put, takeEvery,
} from 'redux-saga/effects';
import api from '../../externals/massItemUploadProxy';
import {
  receiveErrorInMassItemUploadRequest
} from '../actions/errorDialogActions';
import {
  GET_ITEM_ASSIGNMENT_FILE, VALIDATE_MASS_ITEM_ASSIGNMENT_DATA, UPLOAD_MASS_ITEM_DATA, openLoaderMassItemUploadOperation, updateMassItemAssociationData, receiveSuccessResponseInMassItemUploadOperation
} from '../actions/massItemUploadActions';
import { UNABLE_TO_REVALIDATE_MASS_ITEM_DATA, UNABLE_TO_UPLOAD_MASS_ITEM_DATA } from '../../helpers/messageConstant';

export function* getItemAssignmentFile({ data }) {
  try {
    const resultList = yield all([call(api.getMassItemAssociationFile, data), put(openLoaderMassItemUploadOperation('Importing item data from file... this might take a while'))]);
    // result of the first saga effect
    const { massItemFileImportResponse, importedFileName } = resultList[0];
    yield put(updateMassItemAssociationData({ validRecords: massItemFileImportResponse.validItemAssignments, invalidRecords: massItemFileImportResponse.invalidItemAssignments, importedFileName }));
  } catch (e) {
    yield put(receiveErrorInMassItemUploadRequest(e.message));
  }
}

export function* validateMassItemAssignmentData({ data }) {
  try {
    const resultList = yield all([call(api.validateMassItemAssignmentData, data), put(openLoaderMassItemUploadOperation('Re-validating item data... this might take a while'))]);
    const massItemRevalidationResponse = resultList[0];
    yield put(updateMassItemAssociationData({ validRecords: massItemRevalidationResponse.validRecords, invalidRecords: massItemRevalidationResponse.invalidRecords }));
  } catch (e) {
    yield put(receiveErrorInMassItemUploadRequest(UNABLE_TO_REVALIDATE_MASS_ITEM_DATA));
  }
}

export function* uploadMassItemAssignmentData({ data }) {
  try {
    yield all([call(api.uploadMassItemAssignmentData, data), put(openLoaderMassItemUploadOperation('Uploading item data... this might take a while'))]);
    yield all([put(updateMassItemAssociationData({ validRecords: [], invalidRecords: [] })), put(receiveSuccessResponseInMassItemUploadOperation('Item(s) Uploaded Sucessfully'))]);
  } catch (e) {
    yield put(receiveErrorInMassItemUploadRequest(UNABLE_TO_UPLOAD_MASS_ITEM_DATA));
  }
}

export function* massItemUploadSaga() {
  yield takeEvery(GET_ITEM_ASSIGNMENT_FILE, getItemAssignmentFile);
  yield takeEvery(VALIDATE_MASS_ITEM_ASSIGNMENT_DATA, validateMassItemAssignmentData);
  yield takeEvery(UPLOAD_MASS_ITEM_DATA, uploadMassItemAssignmentData);
}
